import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { children as childrenPropType } from 'lib/CustomPropTypes';

function PackageGrid(props) {
  const {
    children,
    maxPerRow,
    zoneType,
  } = props;

  const columns = Array.isArray(children) ? children : [children];

  const numberOfColumns = Math.min(columns.length, maxPerRow);

  return (
    <div
      className={classNames(
        'package-grid',
        `package-grid--columns-${numberOfColumns}`,
        `package-grid--zone-type-${zoneType}`,
      )}
      data-test="package-grid"
    >
      {
        /* eslint-disable react/no-array-index-key */
        // There is no unique identifier for columns, index must be used
        columns.map((col, i) => (
          <div
            className="package-grid__column"
            key={`column-${i}`}
            data-test="package-grid__column"
          >
            {col}
          </div>
        ))
        /* eslint-enable react/no-array-index-key */
      }
    </div>
  );
}

PackageGrid.propTypes = {
  children: childrenPropType,
  maxPerRow: PropTypes.number,
  zoneType: PropTypes.oneOf(['normal', 'rail', 'railAdjacent']),
};

PackageGrid.defaultProps = {
  children: null,
  maxPerRow: 3,
  zoneType: 'normal',
};

export default PackageGrid;
